<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8kJJlH/tc-custom/9781429964449.jpg?1731883592228" alt="This image is the cover for the book Dead Travel Fast"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead Travel Fast
      </h1>
      <p class="bookDescription body article font2">
        <p>The undead are everywhere. They're not just in movies and books, but in commercials, fetish clubs, and even in your breakfast cereal. Bloodsuckers have become some of the most recognizable bad guys in the modern world, and Eric Nuzum wanted to find out why. He was willing to do whatever it took —even drinking his own blood—in his quest to understand the vampire phenomenon. And he found the answer in Goth clubs, darkened parks, haunted houses, and . . . chain restaurants.<br/> In <i>The Dead Travel Fast</i>, Nuzum delivers a far-reaching look at vampires in pop culture from Bram to Bela to Buffy, and at what vampires and vampirism have come to mean to us today. And the blood? Let's just say it doesn't go with eggs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Nuzum
      </h2>
      
      <p class="authorDescription body article"><P><B>Eric Nuzum</B> is a recovering pop culture critic, VH1 pundit, and author of <I>Parental Advisory: Music Censorship in America</I>. He was awarded the 2002 National Edward R. Murrow Award for News Writing and his work has appeared in a few publications you've heard of and many more that you haven't heard of. He works for National Public Radio in Washington, D.C., where he lives with his wife.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52ac700e